import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#666",
      "fill-rule": "nonzero",
      d: "M12.833 5.714c.645 0 1.167.46 1.167 1.029v8.228C14 15.54 13.478 16 12.833 16H1.167C.522 16 0 15.54 0 14.971V6.743c0-.568.522-1.029 1.167-1.029zm0 1.143H1.167v8h11.666zm-5.73 2.286a.5.5 0 0 1 .5.5v2.428a.5.5 0 0 1-.5.5h-.167a.5.5 0 0 1-.5-.5V9.643a.5.5 0 0 1 .5-.5zM7 0c1.933 0 3.5 1.535 3.5 3.429v2.285H9.333V3.43C9.333 2.166 8.29 1.143 7 1.143S4.667 2.166 4.667 3.429v2.285H3.5V3.43C3.5 1.535 5.067 0 7 0"
    }, null, -1)
  ])))
}
export default { render: render }